import React from 'react';
import { Box, TextField } from '@mui/material';

interface DrgCodeTitleFieldsProps {
    code: string;
    title: string;
    codeError?: string;
    titleError?: string;
    onCodeChange: (value: string) => void;
    onTitleChange: (value: string) => void;
}

export const DrgCodeTitleFields: React.FC<DrgCodeTitleFieldsProps> = ({
    code,
    title,
    codeError,
    titleError,
    onCodeChange,
    onTitleChange
}) => {
    return (
        <>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                    label="Code"
                    value={code}
                    onChange={(e) => onCodeChange(e.target.value)}
                    error={!!codeError}
                    helperText={codeError}
                    size="small"
                    fullWidth
                />
            </Box>

            <TextField
                label="Title"
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
                error={!!titleError}
                helperText={titleError}
                fullWidth
                size="small"
            />
        </>
    );
};
